// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"774ae4b3","172":"ef9a91a1","778":"a5944bd2","957":"78673ef1"}[chunkId] + ".chunk.js";
};